module.exports = {"end_scene":{"command":true,"character":"Leon","text":{"en":"Read next...","fr":"Lire la suite..."},"text_mobile":{"en":"Read next...","fr":"Lire la suite..."}},"end_chapter":{"command":true,"character":"Leon","text":{"en":"Continue","fr":"Continuer"},"text_mobile":{"en":"Continue","fr":"Continuer"}},"wait":{"hidden":true,"command":false,"character":"Leon","delay":8,"text":{"en":"","fr":""},"text_mobile":{"en":"","fr":""}}}


//////////////////
// WEBPACK FOOTER
// ./js/data/sentences.json
// module id = 595
// module chunks = 0